import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  status: string;
}

const TaskStatus: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <div className={`badge-base taskstatus ${status}`}>
      <div className="badge-text">
        <span>{t(`taskStatus.${status}`)}</span>
      </div>
    </div>
  );
};

export default React.memo(TaskStatus);
